import React, { useState, useEffect, } from "react";
import { useNavigate } from "react-router-dom";
import { CloudDownload } from 'akar-icons';

import { useDetailsContext } from "../details";
import {
  downloadGpx,
  updateActivityUuid,
} from "../../../services";

import {
  trackAction,
} from "../../../services/mixpanel"

import { deleteActivity, resetActivity, getAllWaypoints } from "../../../services";

import ShareButtons from "./ShareButtons"
import DropdownActionButtons from "./DropdownActionButtons";
import DownloadPdfButton from "../download-pdf-button/download-pdf-button";

import CustomModal from "../../custommodal/CustomModal";
import CopyActivityModal from "../../copy-activity-modal/CopyActivityModal";

import "./activity-editable.css";

import { ReactComponent as SaveSvg } from '../../assets/i_save.svg';
import { ReactComponent as ResetSvg } from '../../assets/i_reset.svg';
import { ReactComponent as EditSvg } from '../../assets/i_edit.svg';
import { ReactComponent as DuplicateSvg } from '../../assets/i_duplicate.svg';
import MobileImgSplits from "../mobile-img-splits/MobileImgSplits";

const ActivityEditable = ({
    id,
    activityDetails,
  }) => {
    const [isEditing, setEditing] = useState();
    const [title, setTitle] = useState();
    const [description, setDescription] = useState();
    const [state, dispatch] = useDetailsContext();
    
    const [showModal, setShowModal] = useState(false);
    const [modalType, setModalType] = useState(false);
    const [modalPayload, setModalPayload] = useState(null);

    const navigate = useNavigate();

    const sendToUpgrade = () => {
      window.location.href = 'https://www.waldup.com/profile#v-pills-subscription';
    };

    const sendToLogin = () => {
      window.location.href = 'https://www.waldup.com/login';
    };

    useEffect(() => {
      if (activityDetails.title) {
        setTitle(activityDetails.title);
          }
      if (activityDetails.description) {
        setDescription(activityDetails.description);
      }
    }, [activityDetails]);

    const closeModalHandler = () => {
      setShowModal(false);
      setModalType(null);
    };
  
    const handleTitleChange = (e) => {
      setTitle(e.target.value);
    };
    const handleDescriptionChange = (e) => {
      setDescription(e.target.value);
    };
  
    const handleActivityEdit = () => {
      setEditing(true);
    };

    // handle updating activity after editing title/description
    const handleActivityUpdate = async (e, title, description, uuid) => {
        // service function to update activity
        // console.log(`activity-editable.js debug - updateActivity with id ${e}`);
        e.preventDefault();
        await updateActivityUuid(uuid, title, description);
        setEditing(false);
    };

    const handleDownloadPDF = () => {
        setModalPayload({
            btnOkCb: () => {
              setModalType(null);
              setShowModal(false);
              sendToUpgrade();
            },
            title: "Download PDF version",
            bodyText: `<b>Finished planning?<br>
            Export to outdoors ready PDF format and take the key information with you (Expert and Pro users only).</b><br>
            <ul><li>Format designed for portability - print, fold & go</li><li>Take an offline copy with you - no data access needed</li><li>Share with your crew</li></ul>`,
            imageURL: "https://waldup.com/static/images/ill-pdf.png",
            okButtonText: "Upgrade",
            showCancelButton: false,
          });
        setShowModal(true);
      };

    const handleDownloadPNG = () => {
      setModalPayload({
          btnOkCb: () => {
            setModalType(null);
            setShowModal(false);
            sendToUpgrade();
          },
          title: "Download Mobile Splits",
          bodyText: `<b>Finished planning?<br>
          Export your splits to a mobile friendly image. Store it in your photo library, or even better set it as wallpaper so you don't even need to unlock your phone! (Expert and Pro users only).</b><br>`,
          imageURL: "https://waldup.com/static/images/ill-mobile.png",
          okButtonText: "Upgrade",
          showCancelButton: false,
        });
      setShowModal(true);
    };
    const handleActivityDelete = () => {
        setModalPayload({
            btnOkCb: () => {
              deleteActivity(id).then(() => {
                navigate('/plan')
              });
              setModalType(null);
              setShowModal(false);
            },
            title: "Delete Activity",
            bodyText: `Are you sure you would like to delete this activity?<br>
            <b>This action can't be undone.</b>`,
            okButtonText: "Delete",
          });
        setShowModal(true);
      };
    
    const handleActivityReset = () => {
        setModalPayload({
            btnOkCb: () => {
              resetActivity(id).then(() => {
                getAllWaypoints(id).then((res) =>
                  dispatch({ type: "FETCH_WAYPOINTS", payload: res })
                );
              });
              setShowModal(false);
            },
            title: "Reset Activity",
            bodyText:
              `This action will reset all waypoint changes<br>
                Are you sure you would like to proceed?<br> 
              <b>This action can't be undone.</b>`,
            okButtonText: "Reset",
          });
        setShowModal(true);
      };

    const handleActivitySaveCopy = () => {
      if (state.isUserLoggedIn) {
        setModalType("activitySaveCopy");
        setShowModal(true);
      }

      else {
        setModalPayload({
          btnOkCb: () => {
            setModalType(null);
            setShowModal(false);
            sendToLogin();
            // console.log("About to save copy of shared activity:"+id);
          },
          title: "Save a copy of this activity",
          bodyText: "Please log in first to use this feature",
          okButtonText: "Login",
        });
        setShowModal(true);
      }
    };
  
    const handleCancel = () => {
      setTitle(activityDetails.title);
      setDescription(activityDetails.description);
      setEditing(false);
    };
  
    const handleDownloadGpx = () => {
      window.location.href = downloadGpx(id);
      trackAction("Download own gpx track",state.allowedCookies);
    };
  
    return (
      <>
        <div className="activity-info-block">
          <form
            className="activity-info-block__form"
            onSubmit={(e) => handleActivityUpdate(e, title, description, activityDetails.uuid)}
          >
            <div className="row">
              <div className="col-lg-6">
                {title && (
                  <input
                    className="activity-info-title"
                    type="text"
                    value={title}
                    onChange={handleTitleChange}
                    readOnly={!isEditing}
                  />
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-lg-8">
                {!!description && (
                  <textarea
                    className="activity-info-descr"
                    onChange={handleDescriptionChange}
                    value={description}
                    placeholder="Go to More > Edit activity to add notes or change the activity name"
                    readOnly={!isEditing}
                  ></textarea>
                )}
                <div>
                  {isEditing ? (
                    <div>
                      <button
                      title="Save changes"
                      className="btn btn-light control-button activity-buttons-more"
                      type="submit">
                      <i className="activity_icons"><SaveSvg /></i>
                      Save Changes
                      </button>
                      <button
                        title="Discard changes"
                        className="btn btn-light control-button activity-buttons-more"
                        onClick={handleCancel}
                      >
                      <i className="activity_icons"><ResetSvg /></i>
                      Discard
                      </button>
                    </div>
                  ): (<div
                    title="Edit name and notes"
                    onClick={handleActivityEdit}
                    className="btn btn-light control-button activity-buttons-more">
                    <i className="activity_icons"><EditSvg /></i>
                    Edit
                    </div>)}
                </div>
              </div>
              <div className="col-lg-4">
                {id && (
                  <div className="control-buttons">
                    <DownloadPdfButton
                      activityDetails={activityDetails}
                      handleDownloadPDF={handleDownloadPDF}
                    />
                    <MobileImgSplits
                      activityDetails={activityDetails}
                      handleDownloadPNG={handleDownloadPNG}
                    />
                    <div
                      title="Download track"
                      className="btn btn-light control-button"
                      onClick={() => {trackAction("Download own gpx track",); handleDownloadGpx(); }}>
                        <CloudDownload strokeWidth={2} size={16} style={{ marginRight: "5px" }}/>
                        Download track
                    </div>
                    <div
                      title="Duplicate activity"
                      className="btn btn-light control-button"
                      onClick={handleActivitySaveCopy}
                      >
                      <i className="activity_icons"><DuplicateSvg /></i>
                          Copy Activity
                      </div>
                    <ShareButtons 
                      id={id}
                      activityDetails={activityDetails}
                      userPrefUnits={state.userPrefUnits}
                      />
                    <DropdownActionButtons
                      handleActivityDelete={handleActivityDelete}
                      handleActivitySaveCopy={handleActivitySaveCopy}
                      handleActivityReset={handleActivityReset}
                      handleActivityEdit={handleActivityEdit}
                      isEditing={isEditing}
                    />
                  </div>
                )}
              </div>
            </div>
          </form>
        </div>
        {showModal && modalType === "activitySaveCopy" &&
        <CopyActivityModal
            payload={modalPayload}
            showModal={showModal}
            closeModalHandler={closeModalHandler}
            handleActivityAdd={null}
            activityDetails={activityDetails}
          />}
        {showModal && modalType !== "activitySaveCopy" &&
        <CustomModal
          payload={modalPayload}
          showModal={showModal}
          closeModalHandler={closeModalHandler}
        />}
      </>
    );
  };
  
  export default ActivityEditable;